import { StatsGeneralCol, StatsGeneralResponse } from 'models/statisticModel';
import React from 'react';
import styles from './stats-general-table.style';

interface Props {
    tableData: StatsGeneralCol[];
    checkDrawBorder: (item: StatsGeneralCol, index: number) => void;
    gameList: any;
    totals: StatsGeneralResponse;
}

// Tên field provider trong gamelst KHÔNG phải lúc nào cũng = providercode.toLowerCase()
// (vd: IBC2 → ibc2sport, DG → dgc, S6 → s2). Các provider còn lại dùng mã viết thường.
const FIELD_OVERRIDE: Record<string, string> = {
    IBC2: 'ibc2sport',
    DG: 'dgc',
    S6: 's2',
    PGSOFT: 'pgs', // field cược PG Soft trong gamelst là `pgs`/`pgswin`
};
const resolveField = (providercode: string, gametype?: string) => {
    // Playtech dùng cùng providercode 'PT' cho cả slot & live nhưng field khác nhau:
    // slot → `pt`, live casino (gametype LC) → `ptc`.
    if (providercode === 'PT') return gametype === 'LC' ? 'ptc' : 'pt';
    return FIELD_OVERRIDE[providercode] || (providercode || '').toLowerCase();
};

// Map nhóm game (gametype) → hậu tố field tổng hợp mà backend trả sẵn.
// Nhóm không có field riêng (vd Bắn Cá FH) sẽ tự cộng các dòng provider trong tab.
const CATEGORY_TOTAL_SUFFIX: Record<string, string> = {
    SL: 'Slot',
    SB: 'Sport',
    LC: 'LiveCasino',
};

function Stats3rdGameTalbe(props: Props) {
    const { tableData, checkDrawBorder, gameList, totals } = props;

    const convertStastGame = (key: string, id: string) => {
        const field = resolveField(key, id);
        return `${formatNumberSeperate(gameList[field]) || 0} / ${formatNumberSeperate(gameList[`${field}win`]) || 0}`;
    };

    const getProfit3rdGame = (key: string, id: string) => {
        const field = resolveField(key, id);
        return formatNumberSeperate(gameList[`${field}win`] - gameList[field], true) || 0;
    };

    const formatNumberSeperate = (num: number | string, hightlight?: boolean) => {
        if (num || Number(num) === 0) {
            let classString = '';
            if (hightlight) {
                if (Number(num) < 0) {
                    classString = 'text-error';
                } else {
                    classString = 'text-success';
                }
                return <span className={classString}>{new Intl.NumberFormat().format(Number(num))}</span>;
            } else {
                return new Intl.NumberFormat().format(Number(num));
            }
        }
        return null;
    };

    // Tổng của 1 tab: ưu tiên field tổng hợp backend (totalBetSlot/totalWinSlot...);
    // nếu nhóm chưa có field riêng thì cộng các dòng provider đang hiển thị trong tab.
    const getTabTotal = (key: string) => {
        const gametype = key.replace('total', '');
        const suffix = CATEGORY_TOTAL_SUFFIX[gametype];
        if (suffix && totals) {
            return {
                bet: Number(totals[`totalBet${suffix}` as keyof StatsGeneralResponse] || 0),
                win: Number(totals[`totalWin${suffix}` as keyof StatsGeneralResponse] || 0),
            };
        }
        // fallback: cộng các provider trong tab (dùng đúng field đã resolve)
        let bet = 0;
        let win = 0;
        tableData
            .filter((item) => !item.key.includes('total'))
            .forEach((item) => {
                const field = resolveField(item.key, item.id);
                bet += Number(gameList[field] || 0);
                win += Number(gameList[`${field}win`] || 0);
            });
        return { bet, win };
    };

    const convertStatsTotal = (key: string, isProfit?: boolean) => {
        const { bet, win } = getTabTotal(key);
        if (isProfit) {
            return formatNumberSeperate(win - bet, true) || 0;
        }
        return `${formatNumberSeperate(bet) || 0} / ${formatNumberSeperate(win) || 0}`;
    };
    return (
        <>
            {tableData.map((item, index) => (
                <React.Fragment key={item.key}>
                    {!item.key.includes('total') ? (
                        <div className={`${styles.group50} ${checkDrawBorder(item, index)}`}>
                            <div className={`${styles.col} ${styles.flex25}`}>{item.label}</div>
                            <div className={`${styles.col} ${styles.flex50} text-center`}>{convertStastGame(item.key, item.id)}</div>
                            <div className={`${styles.col} ${styles.flex25} text-center`}>{getProfit3rdGame(item.key, item.id)}</div>
                        </div>
                    ) : (
                        <div className={styles.group100}>
                            <div className={styles.group50}>
                                <div className={`${styles.col} ${styles.flex25}`}>{item.label}</div>
                                <div className={`${styles.col} ${styles.flex50} text-center`}>{convertStatsTotal(item.key)}</div>
                                <div className={`${styles.col} ${styles.flex25} text-center`}>{convertStatsTotal(item.key, true)} </div>
                            </div>
                            <div className={styles.flex50}></div>
                        </div>
                    )}
                </React.Fragment>
            ))}
        </>
    );
}

export default Stats3rdGameTalbe;
